import { Button, Message } from 'react-bulma-components';
import { Chord, Note, Progression } from '@tonaljs/tonal';
import React, { useState } from 'react';

import AbcNotation from './abc-notation';
import { Notification } from 'react-bulma-components';
import Tippy from '@tippyjs/react';

const TooltipChord = ({ children, ...props }) => {
  const [tooltipVisible, setTooltipVisible] = useState(false);
  //let regex = /(?<tonic>[ABCDEFGH][#b]?)(?<name>[\w#+\/Δ\-°ø]*)/; // Don't understand the 'name' group here?
  let regex = /(?<tonic>([ABCDEFGH]){1}((#|b)?(b|#)?))(?<name>[\w#+\/Δ\-°ø]*)/;
  //let match = regex.exec(children);

  var keytonic = props.t;
  var tonic = "";
  var name = "";
  if (children) {
    let chords = Progression.fromRomanNumerals(keytonic, children);
    let match = regex.exec(chords[0]);
    if (match) {
      tonic = match.groups.tonic;
      name = match.groups.name;
    }
  }

  if(tonic.endsWith("#b") || tonic.endsWith("b#"))
  {
    tonic = tonic.substring(0, tonic.length-2);
  }
  //tonic = Note.simplify(tonic);
  let chord = Chord.getChord(name, tonic + "4");
  if (chord.empty) {
    return (
      <Button size="small" color="danger">'{tonic}'{name}'-{children}</Button>
    )
  }
  else {
    let chordSymbol = chord.symbol.replace("m7-5", "ø")
    .replace("m7b5", "ø")
    .replace("maj","Δ")
    .replace("o","°")
    .replace("dim","°");
    if(props.pop===true)
    {
      chordSymbol = chord.symbol
      .replace(/b/g, '♭')
      .replace(/#/g, '♯');
    }
    
    if(props.pop===true){
      return (
        <Tippy placement="bottom-start" interactive={true} showOnCreate={false} trigger="click" animation={false} content={
          <Message color="success" size='small' style={{ border: '1px solid hsl(171, 100%, 41%)' }}>
            <Message.Header>
            {chord.name}
            </Message.Header>
            <Message.Body style={{ color: 'black' }}>
              <div style={{ width: "250px" }}></div>
              <AbcNotation scientificNotes={chord.notes} clef={props.clef} />
            </Message.Body>
          </Message>
        }>
          <span tabIndex="0">
            <Button size="small" onClick={() => setTooltipVisible(!tooltipVisible)}>{chordSymbol}</Button>
          </span>

        </Tippy>
      )
    }
    else{
      return (
        <Notification color="white" style={{ padding:0,  marginTop: 10, marginBottom: 10, marginRight: 0, minWidth:200, maxWidth: 240 }}>
          <AbcNotation scientificNotes={chord.notes} title={chordSymbol} clef={props.clef}/>
        </Notification>
      )
    }
  }
}

export default TooltipChord;